import { IJob, TranslationKeys } from '~/common/types';

export const JOBS_STATUS_LABEL_LOOKUP: Record<
  IJob['status'],
  keyof TranslationKeys
> = {
  QUEUED: 'app.jobs.status.queued',
  PROCESSING: 'app.jobs.status.processing',
  SUCCEEDED: 'app.jobs.status.completed',
  FAILED: 'app.jobs.status.failed',
};
